import { render, staticRenderFns } from "./jiliangnengli.vue?vue&type=template&id=2ce325fc&scoped=true"
import script from "./jiliangnengli.vue?vue&type=script&lang=js"
export * from "./jiliangnengli.vue?vue&type=script&lang=js"
import style0 from "./jiliangnengli.vue?vue&type=style&index=0&id=2ce325fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce325fc",
  null
  
)

export default component.exports